// https://gist.github.com/ibrechin/2489005
const generateColorSpectrum = (length) => {
  const hslToRgb = (_h, s, l) => {
  	let h = Math.min(_h, 359)/60;

  	let c = (1-Math.abs((2*l)-1))*s;
  	let x = c*(1-Math.abs((h % 2)-1));
  	let m = l - (0.5*c);

  	let r = m, g = m, b = m;

  	if (h < 1) {
  		r += c, g = +x, b += 0;
  	} else if (h < 2) {
  		r += x, g += c, b += 0;
  	} else if (h < 3) {
  		r += 0, g += c, b += x;
  	} else if (h < 4) {
  		r += 0, g += x, b += c;
  	} else if (h < 5) {
  		r += x, g += 0, b += c;
  	} else if (h < 6) {
  		r += c, g += 0, b += x;
  	} else {
  		r = 0, g = 0, b = 0;
  	}

  	return 'rgb(' + Math.floor(r*255) + ', ' + Math.floor(g*255) + ', ' + Math.floor(b*255) + ')';
  }

  const createSpectrum = (length) => {
  	let colors = [];
  	// 270 because we don't want the spectrum to circle back
  	const step = 270/length;
  	for (var i = 1; i <= length; i++) {
  		var color = hslToRgb((i)*step, 0.5, 0.5);
  		colors.push(color);
  	}

  	return colors;
  }

  return createSpectrum(length);
};

export {
  generateColorSpectrum
};



// WEBPACK FOOTER //
// ./src/browser/components/ui/charts/color-data.js